<!-- <button (click)="sendFakeMessages()">Send Fake Messages</button> -->

<!-- Global Loader (full page: only for user-info and navigation; does not cover when body loader is active) -->
@if (loaderService.globalVisible()) {
<div class="global-loader-overlay">
  <div class="global-loader-content">
      <p-progress-spinner strokeWidth="2" fill="transparent" animationDuration="1s" />
  </div>
</div>
}

<router-outlet />
